var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"svg-text"},[_c('img',{staticClass:"svg-text-inner el",attrs:{"src":_vm.src_inner,"alt":""}}),_c('img',{staticClass:"svg-text-outer el",attrs:{"src":_vm.src_outer,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }